import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsArray, IsString, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { SubjectDto } from "../../subjects/response/subject.dto";
import { LevelDto } from "../../levels/response/level.dto";

/** Référence légère pour classe/groupe dans le contexte d'enseignement */
export class ClassGroupRefDto {
  @ApiProperty({ type: 'string' }) id!: string;
  @ApiProperty({ type: 'string' }) name!: string;
}

export class ChapterTeachingContextItemDto {
  @ApiProperty({ type: 'string', format: 'uuid' }) @IsString() teachingId: string;
  @ApiPropertyOptional({ type: () => ClassGroupRefDto, nullable: true })
  @ValidateNested()
  @Type(() => ClassGroupRefDto)
  class?: ClassGroupRefDto | null;
  @ApiPropertyOptional({ type: () => ClassGroupRefDto, nullable: true })
  @ValidateNested()
  @Type(() => ClassGroupRefDto)
  group?: ClassGroupRefDto | null;
}

export class ChapterWithTeachingContextDto {
  @ApiProperty({ type: 'string' }) @IsString() id: string;
  @ApiProperty({ type: 'string' }) @IsString() title: string;
  @ApiPropertyOptional({ type: 'string' }) @IsString() description?: string | null;
  
  @ApiProperty({ type: () => SubjectDto })
  subjectExternal: SubjectDto;
  
  @ApiProperty({ type: () => LevelDto })
  levelExternal: LevelDto;
  
  @ApiProperty({ type: () => [ChapterTeachingContextItemDto] })
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ChapterTeachingContextItemDto)
  teachings: ChapterTeachingContextItemDto[];
}
